import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Input,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { updatePeopleOnPeopleList } from '../actions/People';

import { APIupdatePerson } from '../api/Faces';

import ErrorBoundary from './ErrorBoundary';
import ProcessingSpinner from './ProcessingSpinner';

import { sendTrackingEvent } from '../helpers';

const EditPersonNameModal = ({
  dispatch,
  handleClose,
  person,
}) => {
  const [editedName, setEditedName] = useState(person.name);
  const [similar, setSimilar] = useState(person.similar.length > 0);
  const [saving, setSaving] = useState(false);

  const intl = useIntl();

  useEffect(() => {
    sendTrackingEvent('person-name-edit-modal-opened');
  }, []);

  const handleSave = async () => {
    setSaving(true);
    const response = await APIupdatePerson({
      ...person,
      name: editedName,
    });
    setSaving(false);
    dispatch(updatePeopleOnPeopleList([response]));
    if (response.similar.length > 0) {
      setSimilar(true);
    } else {
      handleClose();
    }

    sendTrackingEvent('person-name-edit-saved');
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setEditedName(value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <ErrorBoundary>
      <ModalHeader toggle={handleClose}>
        {intl.formatMessage({ defaultMessage: 'Change person\'s name' })}
      </ModalHeader>
      <ModalBody style={{ overflow: 'visible' }}>
        {similar && (
          <div className="similar-people">
            {intl.formatMessage({ defaultMessage: 'There are other people with the same name. Consider merging them.' })}
          </div>
        )}
        <Input
          name="editedName"
          defaultValue={editedName}
          autoFocus
          onChange={handleChange}
          onKeyDown={handleKeyPress}
        />
      </ModalBody>
      <ModalFooter>
        <div className="buttons-group">
          <Button
            color="secondary"
            disabled={saving}
            onClick={handleClose}
          >
            {intl.formatMessage({ defaultMessage: 'Cancel' })}
          </Button>
          <Button
            color="primary"
            disabled={saving}
            onClick={handleSave}
          >
            <ProcessingSpinner show={saving} />
            {saving ? (
              intl.formatMessage({ defaultMessage: 'Saving' })
            ) : (
              intl.formatMessage({ defaultMessage: 'Save' })
            )}
          </Button>
        </div>
      </ModalFooter>
    </ErrorBoundary>
  );
};

EditPersonNameModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  person: PropTypes.object.isRequired,
};

export default connect()(EditPersonNameModal);
